<style>svg {
  width: 100%;
}

.stroke-accent {
  stroke: hsl(var(--color-accent));
}</style>

<svg viewBox="0 0 86 52" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g filter="url(#filter0_f_214_5738)">
    <path
      d="M41.0806 15.2072L41.4914 14.8199L41.1267 14.3888C39.476 12.4383 37.4368 10.9517 35.0177 9.93029C32.5997 8.9094 29.9191 8.40415 26.9847 8.40415C23.4704 8.40415 20.2884 9.16376 17.4524 10.6945C14.6184 12.2242 12.3966 14.3519 10.7986 17.0725C9.19863 19.7963 8.40415 22.8685 8.40415 26.2735C8.40415 29.6784 9.19863 32.7506 10.7986 35.4744C12.3956 38.1932 14.6005 40.3209 17.4032 41.8511C20.2087 43.3827 23.3605 44.1428 26.8446 44.1428C29.2739 44.1428 31.6851 43.7671 34.0765 43.018C36.473 42.2673 38.5925 41.1867 40.4282 39.7721L40.6604 39.5932V39.3001V25.7486V25.1527H40.0645H33.1509H32.5551V25.7486V35.1708C30.9845 35.9646 29.225 36.3661 27.265 36.3661C25.3002 36.3661 23.5738 35.9338 22.0694 35.0834C20.5618 34.2311 19.3866 33.0462 18.5363 31.5188C17.688 29.9948 17.2569 28.2515 17.2569 26.2735C17.2569 24.2619 17.6887 22.5031 18.5363 20.9804C19.3853 19.4554 20.5659 18.2796 22.0867 17.4431C23.6073 16.6067 25.3592 16.1808 27.3584 16.1808C30.4867 16.1808 33.1492 17.363 35.3772 19.7602L35.7857 20.1998L36.2224 19.7881L41.0806 15.2072ZM52.0233 43.5702H52.3416L52.5186 43.3055L59.7821 32.4444L67.1798 43.3096L67.3572 43.5702H67.6723H76.4078H77.5577L76.8946 42.6307L64.945 25.7011L76.1002 9.91649L76.7644 8.97676H75.6136H67.4388H67.1237L66.9464 9.23708L60.0534 19.3529L53.0265 9.23277L52.8488 8.97676H52.5371H43.9418H42.7973L43.4537 9.91433L54.7039 25.9842L42.8492 42.6286L42.1786 43.5702H43.3345H52.0233Z"
      class="stroke-accent"
      stroke-opacity="0.3"
      stroke-width="1.1917" />
  </g>
  <g filter="url(#filter1_f_214_5738)">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M32.3532 42.5172C30.1625 43.2034 27.9571 43.5466 25.7372 43.5466C22.5533 43.5466 19.6908 42.8528 17.1495 41.4654C14.6083 40.078 12.6147 38.1535 11.1688 35.692C9.72294 33.2304 9 30.4481 9 27.3451C9 24.242 9.72294 21.4597 11.1688 18.9981C12.6147 16.5366 14.6229 14.6121 17.1933 13.2247C19.7638 11.8373 22.6556 11.1436 25.8686 11.1436C28.5559 11.1436 30.995 11.606 33.1857 12.531C35.3764 13.4559 37.2166 14.7986 38.7063 16.559L34.1496 20.8555C31.9589 18.4984 29.3154 17.3198 26.2192 17.3198C24.2621 17.3198 22.5241 17.7375 21.0052 18.573C19.4863 19.4084 18.3033 20.587 17.4562 22.1087C16.6091 23.6303 16.1856 25.3758 16.1856 27.3451C16.1856 29.2845 16.6091 31.015 17.4562 32.5367C18.3033 34.0584 19.479 35.2444 20.9833 36.0948C22.4876 36.9451 24.2037 37.3703 26.1315 37.3703C28.1762 37.3703 30.0164 36.9227 31.6522 36.0276V26.8527H38.1367V39.5633C36.4718 40.8463 34.5439 41.8309 32.3532 42.5172ZM56.6266 32.1339L49.3533 43.0095H41.2038L52.5518 27.0765L41.7734 11.6806H49.8353L56.8894 21.8401L63.8122 11.6806H71.4797L60.789 26.808L72.2246 43.0095H64.0312L56.6266 32.1339Z"
      class="stroke-accent"
      stroke-opacity="0.9"
      stroke-width="1.11774" />
  </g>
  <g filter="url(#filter2_d_214_5738)">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M32.3532 42.5172C30.1625 43.2034 27.9571 43.5466 25.7372 43.5466C22.5533 43.5466 19.6908 42.8528 17.1495 41.4654C14.6083 40.078 12.6147 38.1535 11.1688 35.692C9.72294 33.2304 9 30.4481 9 27.3451C9 24.242 9.72294 21.4597 11.1688 18.9981C12.6147 16.5366 14.6229 14.6121 17.1933 13.2247C19.7638 11.8373 22.6556 11.1436 25.8686 11.1436C28.5559 11.1436 30.995 11.606 33.1857 12.531C35.3764 13.4559 37.2166 14.7986 38.7063 16.559L34.1496 20.8555C31.9589 18.4984 29.3154 17.3198 26.2192 17.3198C24.2621 17.3198 22.5241 17.7375 21.0052 18.573C19.4863 19.4084 18.3033 20.587 17.4562 22.1087C16.6091 23.6303 16.1856 25.3758 16.1856 27.3451C16.1856 29.2845 16.6091 31.015 17.4562 32.5367C18.3033 34.0584 19.479 35.2444 20.9833 36.0948C22.4876 36.9451 24.2037 37.3703 26.1315 37.3703C28.1762 37.3703 30.0164 36.9227 31.6522 36.0276V26.8527H38.1367V39.5633C36.4718 40.8463 34.5439 41.8309 32.3532 42.5172ZM56.6266 32.1339L49.3533 43.0095H41.2038L52.5518 27.0765L41.7734 11.6806H49.8353L56.8894 21.8401L63.8122 11.6806H71.4797L60.789 26.808L72.2246 43.0095H64.0312L56.6266 32.1339Z"
      class="stroke-accent"
      stroke-width="0.613519"
      shape-rendering="crispEdges" />
  </g>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M32.3532 42.5172C30.1625 43.2034 27.9571 43.5465 25.7372 43.5465C22.5533 43.5465 19.6908 42.8528 17.1495 41.4654C14.6083 40.078 12.6147 38.1535 11.1688 35.692C9.72294 33.2304 9 30.4481 9 27.3451C9 24.242 9.72294 21.4597 11.1688 18.9981C12.6147 16.5366 14.6229 14.6121 17.1933 13.2247C19.7638 11.8373 22.6556 11.1436 25.8686 11.1436C28.5559 11.1436 30.995 11.606 33.1857 12.531C35.3764 13.4559 37.2166 14.7986 38.7063 16.559L34.1496 20.8555C31.9589 18.4984 29.3154 17.3198 26.2192 17.3198C24.2621 17.3198 22.5241 17.7375 21.0052 18.573C19.4863 19.4084 18.3033 20.587 17.4562 22.1087C16.6091 23.6303 16.1856 25.3758 16.1856 27.3451C16.1856 29.2845 16.6091 31.015 17.4562 32.5367C18.3033 34.0584 19.479 35.2444 20.9833 36.0948C22.4876 36.9451 24.2037 37.3703 26.1315 37.3703C28.1762 37.3703 30.0164 36.9227 31.6522 36.0276V26.8527H38.1367V39.5633C36.4718 40.8463 34.5439 41.8309 32.3532 42.5172ZM56.6266 32.1339L49.3533 43.0095H41.2038L52.5518 27.0765L41.7734 11.6806H49.8353L56.8894 21.8401L63.8122 11.6806H71.4797L60.789 26.808L72.2246 43.0095H64.0312L56.6266 32.1339Z"
    class="stroke-accent"
    stroke-width="0.30676" />
  <g filter="url(#filter3_d_214_5738)">
    <path
      d="M12.9095 43.7998V25.9213H18.6004C24.2661 25.9213 27.8922 29.5977 27.8922 34.8857C27.8922 40.1486 24.4172 43.7998 18.676 43.7998H12.9095ZM15.9564 41.0803H18.4997C22.2768 41.0803 24.7446 38.4362 24.7446 34.8857C24.7446 31.2597 22.2517 28.6408 18.6508 28.6408H15.9564V41.0803ZM36.2858 44.0013C32.8863 44.0013 30.343 41.5083 30.343 37.706C30.343 34.0044 32.8863 31.3352 36.2606 31.3352C37.8218 31.3352 39.1816 31.9144 40.0629 33.0223L40.1133 32.9971V31.5115H42.9335V43.7998H40.2392V42.1882L40.1888 42.163C39.3075 43.3465 37.9981 44.0013 36.2858 44.0013ZM36.739 41.4328C38.6528 41.4328 40.2392 39.9471 40.2392 37.7312C40.2392 35.5404 38.7535 33.8785 36.739 33.8785C34.7749 33.8785 33.2137 35.3642 33.2137 37.7312C33.2137 39.8967 34.649 41.4328 36.739 41.4328ZM48.0787 29.6984C47.0211 29.6984 46.1902 28.8423 46.1902 27.8099C46.1902 26.8026 47.0211 25.9465 48.0787 25.9465C49.1363 25.9465 49.9925 26.8026 49.9925 27.8099C49.9925 28.8423 49.1363 29.6984 48.0787 29.6984ZM46.6686 43.7998V31.5115H49.4889V43.7998H46.6686ZM53.5294 43.7998V25.2666H56.3497V43.7998H53.5294ZM61.3302 48.7856L63.5462 43.1199L58.51 31.5115H61.5317L64.906 39.7457H64.9563L68.1039 31.5115H70.9998L64.2512 48.7856H61.3302Z"
      fill="white" />
  </g>
  <defs>
    <filter
      id="filter0_f_214_5738"
      x="0.720733"
      y="0.720977"
      width="85.0744"
      height="51.1049"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
      <feGaussianBlur stdDeviation="3.54381" result="effect1_foregroundBlur_214_5738" />
    </filter>
    <filter
      id="filter1_f_214_5738"
      x="1.79339"
      y="3.93719"
      width="78.1576"
      height="46.8161"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
      <feGaussianBlur stdDeviation="3.32389" result="effect1_foregroundBlur_214_5738" />
    </filter>
    <filter
      id="filter2_d_214_5738"
      x="7.46632"
      y="9.60988"
      width="66.5774"
      height="35.4707"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha" />
      <feOffset />
      <feGaussianBlur stdDeviation="0.613519" />
      <feComposite in2="hardAlpha" operator="out" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0.980392 0 0 0 0 0.117647 0 0 0 0 0.305882 0 0 0 0.8 0" />
      <feBlend
        mode="normal"
        in2="BackgroundImageFix"
        result="effect1_dropShadow_214_5738" />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="effect1_dropShadow_214_5738"
        result="shape" />
    </filter>
    <filter
      id="filter3_d_214_5738"
      x="9.71979"
      y="22.077"
      width="64.4696"
      height="29.8988"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha" />
      <feOffset />
      <feGaussianBlur stdDeviation="1.59482" />
      <feComposite in2="hardAlpha" operator="out" />
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0" />
      <feBlend
        mode="normal"
        in2="BackgroundImageFix"
        result="effect1_dropShadow_214_5738" />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="effect1_dropShadow_214_5738"
        result="shape" />
    </filter>
  </defs>
</svg>
